import Divider from '@mui/material/Divider';

const SidebarDivider = () => (
  <Divider
    ornentation="horizontal"
    sx={{
      backgroundColor: '#2C2C2C'
    }}
  />
);

export default SidebarDivider;